import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/reducer";

// Administration
import User from "./admin/user/reducer";

//roles
import Rol from "./roles/reducer"

// Accounts
import Account from "./account/reducer"

// Accounts
import Campaign from "./campaign/reducer"

// Lengs
import Lengs from "./lengs/reducer"



//Contacts
import Contacts from "./contacts/reducer";


// Dato Contacto
import ContactsData from "./contactsData/reducer";

// Dato Contacto
import ContactsDocument from "./contactsDocument/reducer";


// Casos
import Casos from "./casos/reducer";

// CasosDetalles
import CasosDetalles from "./casosDetalles/reducer";

// GrupoTecnico
import GrupoTecnico from "./grupoTecnico/reducer";


// Informes
import Informes from "./informes/reducer";

// InformeImage
import InformeImage from "./informeImage/reducer";


// Leads
import Leads from "./leads/reducer";

// Agenda
import Agenda from "./agenda/reducer";

// compras
import Compras from "./compras/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  User,
  Rol,
  Account,
  Campaign,
  Lengs,
  Contacts,
  ContactsData,
  ContactsDocument,
  Casos,
  CasosDetalles,
  GrupoTecnico,
  Informes,
  InformeImage,
  Leads,
  Agenda,
  Compras

});

export default rootReducer;
